import { c as _c } from "react/compiler-runtime";
import { Alert } from "@flat-ui";
/**
 * Displays an alert to notify the user about the expiration of their subscription
 */
export function SubscriptionExpirationAlert(t0) {
  const $ = _c(3);
  const {
    description,
    customSx
  } = t0;
  let t1;
  if ($[0] !== customSx || $[1] !== description) {
    t1 = <Alert title={description} variant="warning" sx={customSx} />;
    $[0] = customSx;
    $[1] = description;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}